import React from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Divider, Container, Grid } from '@mui/material';

import { getAllCategories } from '../../apiCalls/urls/urlFunction';
import ProductsBanner from '../../pages/ALLGIFTCARD/LARGEDEVICE/ProductsBanner';
import { updateCategoryReducer } from '../../layouts/innerComponent/NavarCategories/action';
import MobileProductSection from '../mobileComponents/mobileProductCard/MobileProductSection';
import MobileProductCategoryTabs from '../mobileComponents/mobileAllProducts/MobileProductCategoryTabs';

function MobileAllProducts() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    const fetchCategories = async () => {
      const response = await getAllCategories();
      if (response?.status) {
        dispatch(updateCategoryReducer(response?.data));
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <Helmet>
        <title>Explore the Best Gift Cards in India – Shop, Redeem & Enjoy!</title>
        <meta
          name="description"
          content="Discover a wide range of gift cards from top brands on 99Gift. From shopping and dining to entertainment and lifestyle, we offer the perfect gift for any occasion"
        />
        <meta
          property="og:title"
          content="Explore the Best Gift Cards in India – Shop, Redeem & Enjoy!"
        />
        <meta
          property="og:description"
          content="Discover a wide range of gift cards from top brands on 99Gift. From shopping and dining to entertainment and lifestyle, we offer the perfect gift for any occasion"
        />
      </Helmet>

      <Container disableGutters sx={{ bgcolor: 'white.main' }}>
        <Grid
          container
          sx={{
            mb: {
              sm: 3,
              lg: 0,
            },
          }}
        >
          <ProductsBanner />
        </Grid>
        <MobileProductCategoryTabs />
        <Divider />
        <MobileProductSection />
      </Container>
    </>
  );
}

export default MobileAllProducts;
